import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Label = styled.span`
  font-size: 14px;
  color: #a3a4a5;
  font-weight: 800;
`;

const Content = styled.span`
  color: #262626;
  font-size: 18px;
  height: 24px;
  font-weight: 800;
`;

function Description({ label, children }) {
  return (
    <DescriptionWrapper>
      <Label>{label}</Label>
      <Content>{children}</Content>
    </DescriptionWrapper>
  );
}

Description.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Description;
